export default "__VITE_ASSET__8af2d9b1__"